import * as HttpService from "../../../../service/HttpService";

export const getNonInvasiveLoadEconsValue = (id,startDate,endDate) => {
    return HttpService.get(HttpService.DOMAIN + "/nonInvasiveLoad/getNonInvasiveLoadEconsValue?ceCustId="+id+"&startDate="+startDate+"&endDate="+endDate);
};

export const getNilmCecustElecDevClsEloadList = (id,startDate,endDate) => {
    return HttpService.get(HttpService.DOMAIN + "/nonInvasiveLoad/getNilmCecustElecDevClsEloadList?ceCustId="+id+"&startDate="+startDate+"&endDate="+endDate);
};
//获取轨迹回溯信息列表
export const getTrajectoryInfoList = (id,startDate,endDate) => {
    return HttpService.get(HttpService.DOMAIN + "/nonInvasiveLoad/getTrajectoryInfoList?ceCustId="+id+"&startDate="+startDate+"&endDate="+endDate);
};

export const getNilmCecustElecDevClsEloadDayCure = (id,startDate,endDate,no) => {
    return HttpService.get(HttpService.DOMAIN + "/nonInvasiveLoad/getNilmCecustElecDevClsEloadDayCure?ceCustId="+id+"&startDate="+startDate+"&endDate="+endDate+"&elecDevClsNo="+no);
};

export const getCeCustList = (id,type) => {
    return HttpService.get(HttpService.DOMAIN + "/nonInvasiveLoad/getCeCustList?distNeighborhoodResourceId="+id+"&distNeighborhoodResourceType="+type);
};